import React, { useContext, useEffect } from "react";
import { Form, Input, Button, Select, message, Card } from "antd";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const { Option } = Select;

export default function VersionUpdate() {
    const [form] = Form.useForm();
    const { authData, backUrl } = useContext(AuthContext)

    const fetchData = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/app-update-config/`, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });
            form.setFieldsValue(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const onFinish = async (values) => {
        try {
            await axios.post(`${backUrl}/api/emp/app-new-update-config/`, values, {
                headers: {
                    Authorization: `Bearer ${authData?.access}`
                }
            });
            message.success("Updated successfully");
        } catch (err) {
            message.error("Something went wrong");
        }
    };

    return (
        <Card title="App Version Update" style={{ maxWidth: 600, margin: "auto" }}>
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Form.Item
                    name="latest_version"
                    label="Latest Version"
                    rules={[{ required: true, message: "Enter latest version" }]}
                >
                    <Input placeholder="" />
                </Form.Item>

                <Form.Item
                    name="force_update_version"
                    label="Force Update Version"
                    rules={[{ required: true, message: "Enter force update version" }]}
                >
                    <Input placeholder="" />
                </Form.Item>

                <Form.Item
                    name="update_type"
                    label="Update Type"
                    rules={[{ required: true, message: "Select update type" }]}
                >
                    <Select placeholder="Select type">
                        <Option value="flexible">Flexible</Option>
                        <Option value="immediate">Immediate (Force)</Option>
                    </Select>
                </Form.Item>

                <Form.Item
                    name="store_url_android"
                    label="Android Store URL"
                    rules={[{ required: true, message: "Enter Android URL" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="store_url_ios"
                    label="iOS Store URL"
                    rules={[{ required: true, message: "Enter iOS URL" }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    name="remarks"
                    label="Remarks"
                >
                    <Input.TextArea rows={4} placeholder="Enter remarks" />
                </Form.Item>

                <Form.Item>
                    <Button style={{ background: '#0e497b', color: 'white' }} htmlType="submit" block>
                        Trigger Update
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    );
}